package com.evoapps.evoshift.ui.finance

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import com.evoapps.evoshift.domain.explain.Calculation
import com.evoapps.evoshift.domain.explain.PayrollExplanations
import com.evoapps.evoshift.domain.explain.Side

import evoshift.composeapp.generated.resources.note_owner_partner
import com.evoapps.evoshift.navigation.AppShortcut
import com.evoapps.evoshift.navigation.ShortcutHandler
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import com.evoapps.evoshift.viewmodels.Gate
import androidx.compose.material3.TextButton
import androidx.compose.foundation.layout.widthIn
import com.evoapps.evoshift.viewmodels.shows
import androidx.compose.runtime.setValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.mutableStateOf
import evoshift.composeapp.generated.resources.print_payroll
import com.evoapps.evoshift.ui.reports.PrintPayrollDialog
import com.evoapps.evoshift.ui.reports.PrintPerson
import androidx.compose.material.icons.filled.Print
import androidx.compose.material.icons.filled.Download
import androidx.compose.material.icons.filled.Description
import evoshift.composeapp.generated.resources.accountant_export
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.LaunchedEffect
import evoshift.composeapp.generated.resources.labour_cost_export
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.items
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.ExpandLess
import androidx.compose.material.icons.filled.ExpandMore
import androidx.compose.material.icons.filled.Warning
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.text.TextStyle
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.market.payroll.PayLine
import com.evoapps.evoshift.domain.market.payroll.PayLineKind
import com.evoapps.evoshift.domain.market.payroll.PayslipNote
import com.evoapps.evoshift.domain.market.payroll.poland.PolandRates
import com.evoapps.evoshift.domain.model.Adjustment
import com.evoapps.evoshift.domain.model.EmployeePayroll
import com.evoapps.evoshift.domain.model.RosterPayroll
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.adaptive.TableHeaderMaxLines
import com.evoapps.evoshift.ui.adaptive.TableHeaderLineBreak
import com.evoapps.evoshift.ui.adaptive.TableColumn
import com.evoapps.evoshift.ui.adaptive.rememberTableWidths
import com.evoapps.evoshift.ui.adaptive.plusHorizontal
import com.evoapps.evoshift.ui.adaptive.CentredBox
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.hoverLift
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import evoshift.composeapp.generated.resources.employee
import evoshift.composeapp.generated.resources.payroll_col_planned_hours
import evoshift.composeapp.generated.resources.payroll_col_worked_hours
import com.evoapps.evoshift.ui.user.contractLabel
import com.evoapps.evoshift.ui.util.asString
import com.evoapps.evoshift.viewmodels.PayrollViewModel
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.payroll_below_minimum_hourly
import evoshift.composeapp.generated.resources.back
import evoshift.composeapp.generated.resources.employee_contract_type
import evoshift.composeapp.generated.resources.employee_not_set
import evoshift.composeapp.generated.resources.line_accident
import evoshift.composeapp.generated.resources.line_disability
import evoshift.composeapp.generated.resources.line_guarantee_fund
import evoshift.composeapp.generated.resources.line_ppk
import evoshift.composeapp.generated.resources.note_ppk_reduced
import evoshift.composeapp.generated.resources.line_health
import evoshift.composeapp.generated.resources.line_income_tax
import evoshift.composeapp.generated.resources.line_labour_fund
import evoshift.composeapp.generated.resources.line_pension
import evoshift.composeapp.generated.resources.line_sickness
import evoshift.composeapp.generated.resources.note_cap
import evoshift.composeapp.generated.resources.note_contractor
import evoshift.composeapp.generated.resources.note_estimated
import evoshift.composeapp.generated.resources.note_insured_elsewhere
import evoshift.composeapp.generated.resources.note_student
import evoshift.composeapp.generated.resources.note_youth
import evoshift.composeapp.generated.resources.payroll_bonuses
import evoshift.composeapp.generated.resources.payroll_deductions
import evoshift.composeapp.generated.resources.payroll_disclaimer
import evoshift.composeapp.generated.resources.payroll_employee_part
import evoshift.composeapp.generated.resources.payroll_employer_cost
import evoshift.composeapp.generated.resources.payroll_employer_part
import evoshift.composeapp.generated.resources.payroll_empty
import evoshift.composeapp.generated.resources.payroll_gross
import evoshift.composeapp.generated.resources.payroll_hours
import evoshift.composeapp.generated.resources.payroll_missing_rates
import evoshift.composeapp.generated.resources.payroll_refunds
import evoshift.composeapp.generated.resources.payroll_title
import evoshift.composeapp.generated.resources.payroll_to_pay
import org.jetbrains.compose.resources.stringResource
import evoshift.composeapp.generated.resources.monthly_result_actual
import evoshift.composeapp.generated.resources.payroll_employer_cost_plan
import evoshift.composeapp.generated.resources.payroll_plan_vs_actual
import evoshift.composeapp.generated.resources.payroll_row_hours
import evoshift.composeapp.generated.resources.planned
import evoshift.composeapp.generated.resources.missing_pay_set
import evoshift.composeapp.generated.resources.payroll_month_items
import evoshift.composeapp.generated.resources.payroll_no_pay_set
import evoshift.composeapp.generated.resources.payroll_no_pay_set_hint
import evoshift.composeapp.generated.resources.payroll_shifts_cost
import evoshift.composeapp.generated.resources.payroll_works_unpaid
import com.evoapps.evoshift.domain.model.RosterIds
import com.evoapps.evoshift.viewmodels.MissingPayScope

/**
 * "Labour cost" of a month (owner and financial managers): the estimated gross, take-home and
 * employer cost per person with their bonuses, deductions and refunds (SH-78), the printable
 * estimate and the hours export for the accountant.
 * Planning estimates, never payroll (SH-56); the code keeps its payroll names for the maths.
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun PayrollScreen(viewModel: PayrollViewModel, onNavigateBack: () -> Unit) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val widthClass = LocalWindowWidthClass.current
    val openPayTerms = LocalOpenPayTerms.current
    var showPrint by remember { mutableStateOf(false) }
    // SH-117: the working time for the accountant.
    var showAccountant by remember { mutableStateOf(false) }
    // SH-98: Ctrl+P, like the print action in the bar.
    ShortcutHandler(AppShortcut.PRINT, enabled = state.payroll != null && state.capabilities.shows(Gate.PAYROLL)) { showPrint = true }
    val snackbarHostState = remember { SnackbarHostState() }
    val message = state.message?.asString()
    LaunchedEffect(message) {
        message?.let {
            snackbarHostState.showSnackbar(it)
            viewModel.messageShown()
        }
    }
    // SH-78: the bonus, deduction or refund being added (whose) or changed, or deleted.
    var adding by remember { mutableStateOf<EmployeePayroll?>(null) }
    var editing by remember { mutableStateOf<Pair<EmployeePayroll, Adjustment>?>(null) }
    var deleting by remember { mutableStateOf<Pair<String, Adjustment>?>(null) }
    state.payroll?.let { payroll ->
        val dialogFor = adding ?: editing?.first
        if (dialogFor != null) {
            AdjustmentDialog(
                year = payroll.year,
                month = payroll.month,
                currency = payroll.currency,
                shifts = dialogFor.shifts,
                adjustment = editing?.second,
                onDismiss = { adding = null; editing = null },
                onSave = { input ->
                    viewModel.saveAdjustment(dialogFor.userId, input, editingId = editing?.second?.id)
                    adding = null
                    editing = null
                }
            )
        }
        deleting?.let { (userId, adjustment) ->
            DeleteAdjustmentDialog(
                adjustment = adjustment,
                onConfirm = {
                    viewModel.deleteAdjustment(userId, adjustment.id)
                    deleting = null
                },
                onDismiss = { deleting = null }
            )
        }
    }
    state.payroll?.takeIf { showAccountant }?.let { payroll ->
        AccountantExportDialog(rosterId = payroll.rosterId, onDismiss = { showAccountant = false })
    }
    state.payroll?.takeIf { showPrint }?.let { payroll ->
        PrintPayrollDialog(
            rosterId = payroll.rosterId,
            people = payroll.employees.map { PrintPerson(it.userId, it.employeeName) },
            onDismiss = { showPrint = false }
        )
    }
    Scaffold(
        containerColor = Cream,
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            EvoTopBar(
                // The month is the bar's (SH-89); the payroll market's flag stays with the title.
                title = stringResource(Res.string.payroll_title) + (state.payroll?.let { " ${it.market.flag}" } ?: ""),
                onBack = onNavigateBack,
                showWorkplace = true,
                showMonth = true,
                actions = buildList {
                    add(helpAction(HelpPage.LABOUR_COST))
                    if (state.payroll != null && state.capabilities.shows(Gate.PAYROLL)) {
                        // Hours and estimated gross per person for the accountant (SH-56).
                        add(TopBarAction(stringResource(Res.string.labour_cost_export), Icons.Default.Download, { viewModel.exportHours() }))
                        // SH-117: the working-time record, attendance list and payroll-software files.
                        add(TopBarAction(stringResource(Res.string.accountant_export), Icons.Default.Description, { showAccountant = true }))
                        add(TopBarAction(stringResource(Res.string.print_payroll), Icons.Default.Print, { showPrint = true }))
                    }
                }
            )
        }
    ) { padding ->
        val payroll = state.payroll
        val loadError = state.loadError
        when {
            state.isLoading && payroll == null -> Box(Modifier.fillMaxSize().padding(padding), Alignment.Center) { CircularProgressIndicator(color = DeepNavy) }
            // SH-188: the figures could not be read: Try again, not an empty screen.
            payroll == null && loadError != null ->
                com.evoapps.evoshift.widgets.ErrorState(loadError, onRetry = viewModel::retry, modifier = Modifier.padding(padding))
            payroll == null -> Box(Modifier.fillMaxSize().padding(padding), Alignment.Center) {
                Text(state.error?.asString().orEmpty(), color = MaterialTheme.colorScheme.error)
            }
            // SH-130: the list fills the screen (the wheel scrolls it over the empty sides too) and
            // keeps its content in a centred column.
            // SH-152: the figures' explanations name the people of this month.
            else -> androidx.compose.runtime.CompositionLocalProvider(
                LocalExplainNames provides payroll.employees.associate { it.userId to it.employeeName }
            ) { CentredBox(WideContentMaxWidth, Modifier.padding(padding)) { margin ->
                // Desktops get a table: the totals side by side and one aligned row per person, when
                // every header fits in two lines; otherwise the cards.
                val columns = if (widthClass.isExpanded && payroll.employees.isNotEmpty()) {
                    rememberTableWidths(
                        columns = payrollColumns(payroll),
                        available = maxWidth - margin * 2 - 32.dp - PayrollColumns.Inset * 2 - PayrollColumns.Chevron,
                        headerStyle = headerCellStyle(),
                        valueStyle = valueCellStyle(bold = true),
                        cellPadding = PayrollColumns.CellPadding
                    )
                } else null
                val wide = widthClass.isExpanded && (columns != null || payroll.employees.isEmpty())
                LazyColumn(
                    modifier = Modifier.fillMaxSize(),
                    contentPadding = PaddingValues(16.dp).plusHorizontal(margin),
                    verticalArrangement = Arrangement.spacedBy(12.dp)
                ) {
                    // SH-147: people working without pay terms leave the labour cost understated.
                    item(key = "missing-pay") { MissingPayBanner(MissingPayScope(payroll.rosterId)) }
                    item { if (wide) WideTotals(payroll) else Totals(payroll) }
                    if (payroll.employees.isEmpty()) {
                        item { Text(stringResource(Res.string.payroll_empty), color = DeepNavy.copy(alpha = 0.7f)) }
                    } else if (columns != null) {
                        item { TableHeader(columns) }
                    }
                    items(payroll.employees, key = { it.userId }) { employee ->
                        Box(Modifier.animateItemIfMotion(this), propagateMinConstraints = true) {
                            val expanded = state.expandedUserId == employee.userId
                            val adjustments: @Composable () -> Unit = {
                                AdjustmentsSection(
                                    adjustments = employee.adjustments,
                                    shifts = employee.shifts,
                                    currency = payroll.currency,
                                    canEdit = state.canEditAdjustments,
                                    locked = payroll.locked,
                                    onAdd = { adding = employee },
                                    onEdit = { editing = employee to it },
                                    onDelete = { deleting = employee.userId to it }
                                )
                            }
                            // SH-147: "Set pay" on the rows of people without pay terms (those who set pay).
                            val setPay = openPayTerms?.takeIf { state.capabilities.shows(Gate.PAY_EDITING) }?.let { open ->
                                { open(RosterIds.workplaceIdOf(payroll.rosterId), employee.userId) }
                            }
                            if (columns != null) {
                                EmployeeTableRow(employee, payroll.currency, columns, expanded, adjustments, setPay) { viewModel.toggle(employee.userId) }
                            } else {
                                EmployeeCard(employee, payroll.currency, expanded = expanded, adjustments = adjustments, onSetPay = setPay) {
                                    viewModel.toggle(employee.userId)
                                }
                            }
                        }
                    }
                    item {
                        Text(
                            stringResource(Res.string.payroll_disclaimer, PolandRates.forYear(payroll.year).year),
                            style = MaterialTheme.typography.bodySmall,
                            color = DeepNavy.copy(alpha = 0.6f)
                        )
                    }
                }
            } }
        }
    }
}

@Composable
private fun Totals(payroll: RosterPayroll) {
    RegularCard(Modifier.fillMaxWidth()) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            val currency = payroll.currency
            Line(stringResource(Res.string.payroll_gross), formatMoney(payroll.totalGross, currency), calculation = PayrollExplanations.totalGross(payroll), currency = currency)
            Line(stringResource(Res.string.payroll_to_pay), formatMoney(payroll.totalToPay, currency), bold = true, calculation = PayrollExplanations.totalTakeHome(payroll), currency = currency)
            Line(
                stringResource(Res.string.payroll_employer_cost), formatMoney(payroll.totalEmployerCost, currency), bold = true,
                calculation = PayrollExplanations.totalEmployerCost(payroll, Side.ACTUAL), currency = currency
            )
            PlanVsActual(
                plannedHours = payroll.totalPlannedHours,
                hours = payroll.totalPaidHours,
                plannedToPay = payroll.totalPlannedToPay,
                toPay = payroll.totalToPay,
                plannedEmployerCost = payroll.totalPlannedEmployerCost,
                employerCost = payroll.totalEmployerCost,
                currency = payroll.currency,
                toPayWhy = { side -> PayrollExplanations.totalTakeHome(payroll, side) },
                employerCostWhy = { side -> PayrollExplanations.totalEmployerCost(payroll, side) }
            )
            ShiftCostRows(payroll)
        }
    }
}

/**
 * SH-147: the employer cost split as the Finances screen counts it: the shifts' cost alone (their
 * cost snapshots, what Finances and the daily results add up), and the rest the monthly estimate
 * adds on top (bonuses, overtime, Sunday and holiday supplements, the minimum-wage top-up, leave
 * pay, monthly salaries, refunds, contributions worked out on the month).
 */
@Composable
private fun ShiftCostRows(payroll: RosterPayroll) {
    val currency = payroll.currency
    PlanActualRow(
        stringResource(Res.string.payroll_shifts_cost),
        formatMoney(payroll.totalShiftsEmployerCostPlanned, currency),
        formatMoney(payroll.totalShiftsEmployerCost, currency),
        planWhy = PayrollExplanations.shiftsCost(payroll, Side.PLAN),
        actualWhy = PayrollExplanations.shiftsCost(payroll, Side.ACTUAL),
        currency = currency
    )
    PlanActualRow(
        stringResource(Res.string.payroll_month_items),
        formatMoney(payroll.totalPlannedEmployerCost - payroll.totalShiftsEmployerCostPlanned, currency),
        formatMoney(payroll.totalEmployerCost - payroll.totalShiftsEmployerCost, currency),
        planWhy = PayrollExplanations.monthItems(payroll, Side.PLAN),
        actualWhy = PayrollExplanations.monthItems(payroll, Side.ACTUAL),
        currency = currency
    )
}

/**
 * SH-46, the owner's "Raport Wynagrodzeń" plan and real columns: hours, estimated pay-out and
 * employer cost for the rostered hours against the actual ones (clocked where clocked, planned
 * otherwise), with the same bonuses, deductions and refunds.
 */
@Composable
private fun PlanVsActual(
    plannedHours: Double,
    hours: Double,
    plannedToPay: Double,
    toPay: Double,
    plannedEmployerCost: Double,
    employerCost: Double,
    currency: String,
    /** SH-152: how each side's pay-out and employer cost were worked out. */
    toPayWhy: ((Side) -> Calculation?)? = null,
    employerCostWhy: ((Side) -> Calculation?)? = null
) {
    Spacer(Modifier.height(8.dp))
    Text(stringResource(Res.string.payroll_plan_vs_actual), style = MaterialTheme.typography.labelMedium, color = DeepNavy.copy(alpha = 0.7f))
    PlanActualRow("", stringResource(Res.string.planned), stringResource(Res.string.monthly_result_actual), header = true)
    PlanActualRow(stringResource(Res.string.payroll_row_hours), formatDecimal(plannedHours, 1), formatDecimal(hours, 1))
    PlanActualRow(
        stringResource(Res.string.payroll_to_pay), formatMoney(plannedToPay, currency), formatMoney(toPay, currency),
        planWhy = toPayWhy?.invoke(Side.PLAN), actualWhy = toPayWhy?.invoke(Side.ACTUAL), currency = currency
    )
    PlanActualRow(
        stringResource(Res.string.payroll_employer_cost), formatMoney(plannedEmployerCost, currency), formatMoney(employerCost, currency),
        planWhy = employerCostWhy?.invoke(Side.PLAN), actualWhy = employerCostWhy?.invoke(Side.ACTUAL), currency = currency
    )
}

@Composable
private fun PlanActualRow(
    label: String,
    plan: String,
    actual: String,
    header: Boolean = false,
    planWhy: Calculation? = null,
    actualWhy: Calculation? = null,
    currency: String = ""
) {
    val style = if (header) MaterialTheme.typography.labelSmall.copy(fontWeight = FontWeight.Bold) else MaterialTheme.typography.bodySmall
    val color = DeepNavy.copy(alpha = if (header) 0.6f else 0.9f)
    Row(Modifier.fillMaxWidth().padding(vertical = 2.dp), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(label, Modifier.weight(1.15f), style = style, color = color)
        Box(Modifier.weight(1f), contentAlignment = Alignment.CenterEnd) {
            ExplainableAmount(plan, planWhy, currency, style = style, color = color, textAlign = TextAlign.End)
        }
        Box(Modifier.weight(1f), contentAlignment = Alignment.CenterEnd) {
            ExplainableAmount(actual, actualWhy, currency, style = style, color = color, textAlign = TextAlign.End)
        }
    }
}

@Composable
private fun EmployeePlanVsActual(employee: EmployeePayroll, currency: String) = PlanVsActual(
    plannedHours = employee.plannedHours,
    hours = employee.paidHours,
    plannedToPay = employee.plannedToPay,
    toPay = employee.toPay,
    plannedEmployerCost = employee.plannedEmployerCost,
    employerCost = employee.employerCost,
    currency = currency,
    toPayWhy = { side -> PayrollExplanations.takeHome(employee, side) },
    employerCostWhy = { side -> PayrollExplanations.employerCost(employee, side) }
)

@Composable
private fun EmployeeCard(
    employee: EmployeePayroll,
    currency: String,
    expanded: Boolean,
    adjustments: @Composable () -> Unit,
    onSetPay: (() -> Unit)? = null,
    onToggle: () -> Unit
) {
    RegularCard(Modifier.fillMaxWidth().hoverLift(), onClick = onToggle) {
        Column(Modifier.padding(16.dp)) {
            // Phones and tablets: name and estimated pay-out on top, then the contract and hours and
            // the employer cost each on a full-width line, so neither squeezes the other.
            Row(verticalAlignment = Alignment.CenterVertically) {
                Text(employee.employeeName, fontWeight = FontWeight.Bold, color = DeepNavy, modifier = Modifier.weight(1f))
                ExplainableAmount(
                    moneyOrPayStatus(employee, employee.toPay, currency),
                    PayrollExplanations.takeHome(employee, Side.ACTUAL),
                    currency,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy,
                    modifier = Modifier.padding(start = 12.dp)
                )
                Icon(if (expanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore, null, tint = DeepNavy)
            }
            Text(
                "${contractText(employee)} · " + stringResource(
                    Res.string.payroll_hours, formatDecimal(employee.plannedHours, 1), formatDecimal(employee.workedHours, 1)
                ),
                style = MaterialTheme.typography.bodySmall,
                color = DeepNavy.copy(alpha = 0.7f)
            )
            Row(Modifier.padding(top = 2.dp)) {
                Text("${stringResource(Res.string.payroll_employer_cost)}: ", style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f))
                ExplainableAmount(
                    moneyOrPayStatus(employee, employee.employerCost, currency),
                    PayrollExplanations.employerCost(employee, Side.ACTUAL),
                    currency,
                    style = MaterialTheme.typography.bodySmall,
                    color = DeepNavy.copy(alpha = 0.7f)
                )
            }
            MissingPayNote(employee, onSetPay, Modifier.padding(top = 4.dp))
            if (employee.shiftsWithoutCost > 0 && !employee.missingPay) {
                Row(Modifier.padding(top = 8.dp), verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Default.Warning, null, tint = Color(0xFFD32F2F), modifier = Modifier.size(16.dp))
                    Spacer(Modifier.width(6.dp))
                    Text(stringResource(Res.string.payroll_missing_rates, employee.shiftsWithoutCost), color = Color(0xFFD32F2F), style = MaterialTheme.typography.bodySmall)
                }
            }
            MinimumRateWarning(employee, currency, Modifier.padding(top = 8.dp))
            if (expanded) {
                HorizontalDivider(Modifier.padding(vertical = 12.dp), color = DeepNavy.copy(alpha = 0.15f))
                EmployeeSide(employee, currency)
                EmployerSide(employee, currency)
                EmployeePlanVsActual(employee, currency)
                adjustments()
            }
        }
    }
}

/** The estimate from the gross down to what is paid out. */
@Composable
private fun EmployeeSide(employee: EmployeePayroll, currency: String) {
    val slip = employee.payslip
    Line(stringResource(Res.string.payroll_gross), formatMoney(slip.gross, currency), bold = true, calculation = PayrollExplanations.gross(employee, Side.ACTUAL), currency = currency)
    if (employee.bonuses > 0) Line("  ${stringResource(Res.string.payroll_bonuses)}", formatMoney(employee.bonuses, currency))
    // SH-57: overtime, Sunday and holiday work, the minimum-wage top-up, leave and pay changes, each on its own line.
    employee.factors?.let { factors -> payFactorLines(factors, currency).forEach { (label, amount) -> Line("  $label", amount) } }
    Section(stringResource(Res.string.payroll_employee_part), slip.employeeLines, currency)
    if (employee.deductions > 0) Line(stringResource(Res.string.payroll_deductions), "−" + formatMoney(employee.deductions, currency))
    if (employee.expenseRefunds > 0) Line(stringResource(Res.string.payroll_refunds), "+" + formatMoney(employee.expenseRefunds, currency))
    Line(stringResource(Res.string.payroll_to_pay), formatMoney(employee.toPay, currency), bold = true, calculation = PayrollExplanations.takeHome(employee, Side.ACTUAL), currency = currency)
}

/** What the employer pays on top, and the notes on how the estimate was worked out. */
@Composable
private fun EmployerSide(employee: EmployeePayroll, currency: String) {
    val slip = employee.payslip
    Section(stringResource(Res.string.payroll_employer_part), slip.employerLines, currency)
    Line(stringResource(Res.string.payroll_employer_cost), formatMoney(employee.employerCost, currency), bold = true, calculation = PayrollExplanations.employerCost(employee, Side.ACTUAL), currency = currency)
    slip.notes.forEach { note ->
        Text("• " + noteText(note), style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f), modifier = Modifier.padding(top = 4.dp))
    }
    employee.factors?.let { factors ->
        payFactorNotes(factors, currency, rateWarning = false).forEach { note ->
            Text("• $note", style = MaterialTheme.typography.bodySmall, color = DeepNavy.copy(alpha = 0.7f), modifier = Modifier.padding(top = 4.dp))
        }
    }
}

/** Column widths of the desktop table, shared by the header and the rows so they line up. */
private object PayrollColumns {
    const val NAME = 2.2f
    const val CONTRACT = 1.5f
    const val HOURS = 0.9f
    const val MONEY = 1.2f
    val Chevron = 24.dp

    /** Each cell's inner space on the left and the right. */
    val CellPadding = 6.dp

    /** RegularCard's frame (5dp) plus the row's own padding (16dp): where a row's text starts. */
    val Inset = 21.dp
}

@Composable
private fun WideTotals(payroll: RosterPayroll) {
    RegularCard(Modifier.fillMaxWidth()) {
        Row(Modifier.padding(horizontal = 24.dp, vertical = 20.dp)) {
            listOf(
                Triple(stringResource(Res.string.payroll_gross), payroll.totalGross, PayrollExplanations.totalGross(payroll)),
                Triple(stringResource(Res.string.payroll_to_pay), payroll.totalToPay, PayrollExplanations.totalTakeHome(payroll)),
                Triple(stringResource(Res.string.payroll_employer_cost_plan), payroll.totalPlannedEmployerCost, PayrollExplanations.totalEmployerCost(payroll, Side.PLAN)),
                Triple(stringResource(Res.string.payroll_employer_cost), payroll.totalEmployerCost, PayrollExplanations.totalEmployerCost(payroll, Side.ACTUAL))
            ).forEachIndexed { index, (label, amount, why) ->
                val emphasised = index % 2 == 1
                Column(Modifier.weight(1f)) {
                    Text(label, style = MaterialTheme.typography.labelMedium, color = DeepNavy.copy(alpha = 0.7f))
                    Spacer(Modifier.height(4.dp))
                    ExplainableAmount(
                        formatMoney(amount, payroll.currency),
                        why,
                        payroll.currency,
                        style = MaterialTheme.typography.headlineSmall,
                        fontWeight = if (emphasised) FontWeight.Bold else FontWeight.SemiBold,
                        color = DeepNavy
                    )
                }
            }
        }
        // SH-147: how the employer cost compares with the Finances screen's labour cost.
        Column(Modifier.padding(start = 24.dp, end = 24.dp, bottom = 16.dp).widthIn(max = 640.dp)) {
            PlanActualRow(stringResource(Res.string.payroll_employer_cost), stringResource(Res.string.planned), stringResource(Res.string.monthly_result_actual), header = true)
            ShiftCostRows(payroll)
        }
    }
}

/**
 * The table's columns, in order (SH-130): the amounts and hours must show whole, so their widest
 * values count towards the columns' widths; names and contracts may be shortened.
 */
@Composable
private fun payrollColumns(payroll: RosterPayroll): List<TableColumn> {
    val currency = payroll.currency
    val people = payroll.employees
    @Composable
    fun shown(amount: (EmployeePayroll) -> Double) = people.map { moneyOrPayStatus(it, amount(it), currency) }
    return listOf(
        TableColumn(stringResource(Res.string.employee), PayrollColumns.NAME),
        TableColumn(stringResource(Res.string.employee_contract_type), PayrollColumns.CONTRACT),
        TableColumn(stringResource(Res.string.payroll_col_planned_hours), PayrollColumns.HOURS, people.map { formatDecimal(it.plannedHours, 1) }),
        TableColumn(stringResource(Res.string.payroll_col_worked_hours), PayrollColumns.HOURS, people.map { formatDecimal(it.workedHours, 1) }),
        TableColumn(stringResource(Res.string.payroll_gross), PayrollColumns.MONEY, shown { it.payslip.gross }),
        TableColumn(stringResource(Res.string.payroll_to_pay), PayrollColumns.MONEY, shown { it.toPay }),
        TableColumn(stringResource(Res.string.payroll_employer_cost_plan), PayrollColumns.MONEY, shown { it.plannedEmployerCost }),
        TableColumn(stringResource(Res.string.payroll_employer_cost), PayrollColumns.MONEY, shown { it.employerCost })
    )
}

@Composable
private fun headerCellStyle(): TextStyle = MaterialTheme.typography.labelMedium.copy(fontWeight = FontWeight.Bold)

@Composable
private fun valueCellStyle(bold: Boolean): TextStyle =
    MaterialTheme.typography.bodyMedium.copy(fontWeight = if (bold) FontWeight.Bold else FontWeight.Normal)

/** The headers over [widths] (rememberTableWidths): up to two balanced lines, never cut short. */
@Composable
private fun TableHeader(widths: List<Dp>) {
    val headers = payrollHeaders()
    Row(
        Modifier.fillMaxWidth().padding(horizontal = PayrollColumns.Inset).padding(top = 8.dp),
        verticalAlignment = Alignment.Bottom
    ) {
        headers.forEachIndexed { i, header ->
            Text(
                header,
                Modifier.width(widths[i]).padding(horizontal = PayrollColumns.CellPadding),
                style = headerCellStyle().copy(lineBreak = TableHeaderLineBreak),
                color = DeepNavy.copy(alpha = 0.7f),
                textAlign = if (i < 2) TextAlign.Start else TextAlign.End,
                maxLines = TableHeaderMaxLines
            )
        }
        Spacer(Modifier.width(PayrollColumns.Chevron))
    }
}

@Composable
private fun payrollHeaders(): List<String> = listOf(
    stringResource(Res.string.employee),
    stringResource(Res.string.employee_contract_type),
    stringResource(Res.string.payroll_col_planned_hours),
    stringResource(Res.string.payroll_col_worked_hours),
    stringResource(Res.string.payroll_gross),
    stringResource(Res.string.payroll_to_pay),
    stringResource(Res.string.payroll_employer_cost_plan),
    stringResource(Res.string.payroll_employer_cost)
)

@Composable
private fun ValueCell(text: String, width: Dp, align: TextAlign = TextAlign.End, bold: Boolean = false, why: Calculation? = null, currency: String = "") {
    ExplainableAmount(
        text,
        why,
        currency,
        Modifier.width(width).padding(horizontal = PayrollColumns.CellPadding),
        style = valueCellStyle(bold),
        color = DeepNavy,
        textAlign = align,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis
    )
}

/**
 * One person on a wide window: the figures in table columns, and when opened the estimate in two
 * halves (the employee's side, the employer's side) instead of one long list.
 */
@Composable
private fun EmployeeTableRow(
    employee: EmployeePayroll,
    currency: String,
    widths: List<Dp>,
    expanded: Boolean,
    adjustments: @Composable () -> Unit,
    onSetPay: (() -> Unit)?,
    onToggle: () -> Unit
) {
    RegularCard(Modifier.fillMaxWidth().hoverLift(), onClick = onToggle) {
        Column(Modifier.padding(16.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                ValueCell(employee.employeeName, widths[0], TextAlign.Start, bold = true)
                ValueCell(contractText(employee), widths[1], TextAlign.Start)
                ValueCell(formatDecimal(employee.plannedHours, 1), widths[2])
                ValueCell(formatDecimal(employee.workedHours, 1), widths[3])
                ValueCell(moneyOrPayStatus(employee, employee.payslip.gross, currency), widths[4], why = PayrollExplanations.gross(employee, Side.ACTUAL), currency = currency)
                ValueCell(moneyOrPayStatus(employee, employee.toPay, currency), widths[5], bold = true, why = PayrollExplanations.takeHome(employee, Side.ACTUAL), currency = currency)
                ValueCell(moneyOrPayStatus(employee, employee.plannedEmployerCost, currency), widths[6], why = PayrollExplanations.employerCost(employee, Side.PLAN), currency = currency)
                ValueCell(moneyOrPayStatus(employee, employee.employerCost, currency), widths[7], why = PayrollExplanations.employerCost(employee, Side.ACTUAL), currency = currency)
                Icon(
                    if (expanded) Icons.Default.ExpandLess else Icons.Default.ExpandMore,
                    null,
                    tint = DeepNavy,
                    modifier = Modifier.size(PayrollColumns.Chevron)
                )
            }
            MissingPayNote(employee, onSetPay, Modifier.padding(top = 4.dp, start = 6.dp))
            if (employee.shiftsWithoutCost > 0 && !employee.missingPay) {
                Row(Modifier.padding(top = 8.dp, start = 6.dp), verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Default.Warning, null, tint = Color(0xFFD32F2F), modifier = Modifier.size(16.dp))
                    Spacer(Modifier.width(6.dp))
                    Text(stringResource(Res.string.payroll_missing_rates, employee.shiftsWithoutCost), color = Color(0xFFD32F2F), style = MaterialTheme.typography.bodySmall)
                }
            }
            MinimumRateWarning(employee, currency, Modifier.padding(top = 8.dp, start = 6.dp))
            if (expanded) {
                HorizontalDivider(Modifier.padding(vertical = 12.dp), color = DeepNavy.copy(alpha = 0.15f))
                Row(Modifier.padding(horizontal = 6.dp), horizontalArrangement = Arrangement.spacedBy(48.dp)) {
                    Column(Modifier.weight(1f)) { EmployeeSide(employee, currency) }
                    Column(Modifier.weight(1f)) { EmployerSide(employee, currency); EmployeePlanVsActual(employee, currency) }
                }
                Column(Modifier.padding(horizontal = 6.dp)) { adjustments() }
            }
        }
    }
}

/**
 * SH-147: [amount], unless nothing is known about the person's pay: "No pay set" (not 0,00 zł)
 * for someone without pay terms, "Works without pay" for the owner without them.
 */
@Composable
private fun moneyOrPayStatus(employee: EmployeePayroll, amount: Double, currency: String): String = when {
    employee.missingPay -> stringResource(Res.string.payroll_no_pay_set)
    employee.worksWithoutPay -> stringResource(Res.string.payroll_works_unpaid)
    else -> formatMoney(amount, currency)
}

/** SH-147: "No pay set: the labour cost leaves these shifts out" with "Set pay" ([onSetPay], those who set pay). */
@Composable
private fun MissingPayNote(employee: EmployeePayroll, onSetPay: (() -> Unit)?, modifier: Modifier) {
    if (!employee.missingPay) return
    Row(modifier, verticalAlignment = Alignment.CenterVertically) {
        Icon(Icons.Default.Warning, null, tint = Color(0xFFD32F2F), modifier = Modifier.size(16.dp))
        Spacer(Modifier.width(6.dp))
        Text(
            stringResource(Res.string.payroll_no_pay_set_hint, employee.shifts.size),
            color = Color(0xFFD32F2F),
            style = MaterialTheme.typography.bodySmall,
            modifier = Modifier.weight(1f, fill = false)
        )
        if (onSetPay != null) {
            TextButton(onClick = onSetPay) {
                Text(stringResource(Res.string.missing_pay_set), color = DeepNavy, fontWeight = FontWeight.Bold)
            }
        }
    }
}

/** SH-57: a civil-law contract's rate under the year's minimum hourly rate. */
@Composable
private fun MinimumRateWarning(employee: EmployeePayroll, currency: String, modifier: Modifier) {
    val minimum = employee.factors?.minimumHourlyRate ?: return
    Row(modifier, verticalAlignment = Alignment.CenterVertically) {
        Icon(Icons.Default.Warning, null, tint = Color(0xFFD32F2F), modifier = Modifier.size(16.dp))
        Spacer(Modifier.width(6.dp))
        Text(
            stringResource(Res.string.payroll_below_minimum_hourly, formatMoney(minimum, currency)),
            color = Color(0xFFD32F2F),
            style = MaterialTheme.typography.bodySmall
        )
    }
}

@Composable
private fun contractText(employee: EmployeePayroll): String =
    if (employee.contract == com.evoapps.evoshift.domain.model.SystemContractType.NOT_SET) {
        "${stringResource(Res.string.employee_contract_type)}: ${stringResource(Res.string.employee_not_set)}"
    } else contractLabel(employee.contract)

@Composable
private fun Section(title: String, lines: List<PayLine>, currency: String) {
    if (lines.isEmpty()) return
    Spacer(Modifier.height(8.dp))
    Text(title, style = MaterialTheme.typography.labelMedium, color = DeepNavy.copy(alpha = 0.7f))
    lines.filter { it.amount != 0.0 || it.kind == PayLineKind.INCOME_TAX }.forEach {
        Line("  ${lineName(it.kind)}", formatMoney(it.amount, currency))
    }
}

@Composable
private fun Line(label: String, value: String, bold: Boolean = false, calculation: Calculation? = null, currency: String = "") {
    Row(Modifier.fillMaxWidth().padding(vertical = 2.dp)) {
        Text(label, Modifier.weight(1f), color = DeepNavy.copy(alpha = if (bold) 1f else 0.8f), style = MaterialTheme.typography.bodyMedium,
            fontWeight = if (bold) FontWeight.Bold else FontWeight.Normal)
        ExplainableAmount(value, calculation, currency, color = DeepNavy, style = MaterialTheme.typography.bodyMedium, fontWeight = if (bold) FontWeight.Bold else FontWeight.Normal)
    }
}

@Composable
internal fun lineName(kind: PayLineKind): String = stringResource(
    when (kind) {
        PayLineKind.PENSION -> Res.string.line_pension
        PayLineKind.DISABILITY -> Res.string.line_disability
        PayLineKind.SICKNESS -> Res.string.line_sickness
        PayLineKind.ACCIDENT -> Res.string.line_accident
        PayLineKind.HEALTH -> Res.string.line_health
        PayLineKind.INCOME_TAX -> Res.string.line_income_tax
        PayLineKind.LABOUR_FUND -> Res.string.line_labour_fund
        PayLineKind.GUARANTEE_FUND -> Res.string.line_guarantee_fund
        PayLineKind.PPK -> Res.string.line_ppk
    }
)

@Composable
private fun noteText(note: PayslipNote): String = stringResource(
    when (note) {
        PayslipNote.YOUTH_RELIEF -> Res.string.note_youth
        PayslipNote.STUDENT_EXEMPT -> Res.string.note_student
        PayslipNote.INSURED_ELSEWHERE -> Res.string.note_insured_elsewhere
        PayslipNote.CONTRIBUTION_CAP_REACHED -> Res.string.note_cap
        PayslipNote.CONTRACTOR -> Res.string.note_contractor
        PayslipNote.OWNER_PARTNER -> Res.string.note_owner_partner
        PayslipNote.RATES_ESTIMATED -> Res.string.note_estimated
        PayslipNote.PPK_REDUCED -> Res.string.note_ppk_reduced
    }
)
